document.querySelectorAll('.link-icon-with-text__link').forEach(function(el) {
  el.addEventListener('click', function (event) {
    console.log("pöö");
    const closest = event.target.closest('.link-icon-with-text');
    closest.classList.toggle('readmore-open');

  });
});
